import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/number.js'
import '../../assets/scripts/jquery.lettering.js'
import '../../assets/scripts/jquery.textillate.js'

$("header .nav ul li").eq(0).addClass("active");

// 首页轮播
var banner = new Swiper('.banner .swiper-container', {
	autoplay: {
        delay: 5000,
        disableOnInteraction: false,
	},
	speed:1000,
	loop:true,//必须
  // 左右按钮
  navigation: {
    nextEl: ".banner .swiper-button-next",
    prevEl: ".banner .swiper-button-prev",
  },
  // 只启用一个 pagination（进度条）
  pagination: {
    el: ".banner .swiper-pagination.progress",
    type: "progressbar",
  },
  on: {
    init: function () {
      renderNumbers(this);
    },
    slideChange: function () {
      renderNumbers(this);
    }
  }
}); 

// 自定义 01 02 03
function renderNumbers(swiper) {
  const slides = swiper.wrapperEl.querySelectorAll(
    '.swiper-slide:not(.swiper-slide-duplicate)'
  );

  const total = slides.length;
  const current = swiper.realIndex;

  const format = (n) => (n < 9 ? "0" + (n + 1) : n + 1);

  let html = "";

  for (let i = 0; i < total; i++) {
    html += `<span class="num ${i === current ? "active" : ""}" data-index="${i}">
      ${format(i)}
    </span>`;
  }

  const container = document.querySelector(".banner .swiper-pagination.custom");
  container.innerHTML = html;

  // 点击跳转（关键点）
  container.querySelectorAll(".num").forEach(el => {
    el.onclick = () => {
      swiper.slideToLoop(parseInt(el.dataset.index));
    };
  });
}


var swiper = new Swiper(".section2 .mySwiper", {
    spaceBetween: '4%',
    slidesPerView: 4,
     breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        spaceBetween: '4%',
        slidesPerView: 4,
      },
      768: {  //当屏幕宽度小于等于768
        spaceBetween: '3%',
        slidesPerView: 3,
      },
      320: {  //当屏幕宽度小于等于320
        spaceBetween: '2%',
        slidesPerView: 2,
      }
    } 
});
var swiper2 = new Swiper(".section2 .mySwiper2", {
    thumbs: {
        swiper: swiper,
    },
    navigation: {
        nextEl: ".section2  .swiper-button-next",
        prevEl: ".section2  .swiper-button-prev",
    },
});


var banner = new Swiper('.section3 .swiper-container', {
  slidesPerView: 1.578,
  spaceBetween: 30,
  centeredSlides: true,
  // 只启用一个 pagination（进度条）
  pagination: {
    el: ".section3 .swiper-pagination.progress",
    type: "progressbar",
  },
  breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
          slidesPerView: 1.578,
          spaceBetween: 30,
      },
      768: {  //当屏幕宽度小于等于768
          slidesPerView: 1.3,
          spaceBetween: 20,
      },
      320: {  //当屏幕宽度小于等于320
          slidesPerView: 1,
          spaceBetween: 0,
      }
    },
  on: {
    init: function () {
      renderNumbers1(this);
    },
    slideChange: function () {
      renderNumbers1(this);
    }
  }
}); 

// 自定义 01 02 03
function renderNumbers1(swiper) {
  const slides = swiper.wrapperEl.querySelectorAll(
    '.swiper-slide:not(.swiper-slide-duplicate)'
  );

  const total = slides.length;
  const current = swiper.realIndex;

  const format = (n) => (n < 9 ? "0" + (n + 1) : n + 1);

  let html = "";

  for (let i = 0; i < total; i++) {
    html += `<span class="num ${i === current ? "active" : ""}" data-index="${i}">
      ${format(i)}
    </span>`;
  }

  const container = document.querySelector(".section3 .swiper-pagination.custom");
  container.innerHTML = html;

  // 点击跳转（关键点）
  container.querySelectorAll(".num").forEach(el => {
    el.onclick = () => {
      swiper.slideToLoop(parseInt(el.dataset.index));
    };
  });
}



$(".solution-nav ul li").eq(0).addClass("active");
$(".solution-list a").eq(0).addClass("active");
$(".solution-nav ul li").hover(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".solution-list a").eq(index).addClass("active").siblings().removeClass("active");
})

var case1 = new Swiper(".section7 .mySwiper", {
    spaceBetween: '7.45%',
    slidesPerView: 3,
  breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
          spaceBetween: '7.45%',
          slidesPerView: 3,
      },
      768: {  //当屏幕宽度小于等于768
          spaceBetween: '2%',
          slidesPerView: 3,
      },
      320: {  //当屏幕宽度小于等于320
          slidesPerView: 3,
          spaceBetween: 10,
      }
    },
  
});
var case2 = new Swiper(".section7 .mySwiper2", {
    thumbs: {
        swiper: case1,
    }, 
});  